export const generateMicrolessonsText = {
  title: 'Tapybl AI',
  subtitle: 'Powered by AI, driven by you',
  generateTitle: 'Create new microlesson',
  promptTitle: 'Topic',
  promptSubtitle:
    "Enter a topic, and we'll generate a complete learning package for you— including a structured document, an AI-narrated video, and an interactive lesson. This may take a few minutes - we'll notify you when it's ready",
  promptPlaceholder: 'Enter an idea to generate an interactive video lesson',
  titleField: 'Title',
  titleDescription: 'Choose a title for your generated content',
  includeBranching: 'Personalized pathways',
  branchingSubtitle: 'Allow your learners to select their own learning paths',
  includeGrading: 'Verify learner comprehension',
  assesmentSubtitle:
    'Verify learner comprehension levels using auto-generated assessments',
  passingScore: 'Passing score',
  passingScoreSubtitle: 'Set the minimum passing score (0-100)',
  cancel: 'Cancel',
  generate: 'Generate lesson',
  generationStarted: 'Lesson generation started',
  source: 'Source',
  sourceSubtitle:
    'Generate a new microlesson from an existing prompt or video!',
  videoTitle: 'Video source',
  lessonIsBeingGenerated:
    'Lesson generation can take up to 5 minutes. Check microlessons page for details.',
  lessonIsGenerated: 'Your lesson is generated',
  selectLanguage: 'Select language',
  selectLanguageSubtitle:
    'Select the language in which you wish to generate content',
  documentTitle: 'Upload a file (PDF, DOCX or PPTX)',
  documentRequirements: 'Up to 110 slides/pages per file',
  enableAckNode: 'Enable acknowledgement node',
  enableAckNodeSubtitle:
    'Insert an acknowledgement step in microreels so learners can confirm understanding before continuing',
  generateMicroreels:
    'Do you want to generate microreels for this microlesson?',
};
